import Cookies from "js-cookie";
import { requestTypes } from "../_redux/_constants/common.constants";

export const getRequestHeader = (method) => {
    return authHeader(method);
};

function authHeader(method) {
    if (method === requestTypes.REQUEST_TYPE_POST) {
        return {
            "Content-Type": "application/json",
            "XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
        };
    } else if (method === requestTypes.REQUEST_TYPE_GET) {
        return {
            "Content-Type": "application/x-www-form-urlencoded",
        };
    } else {
        return {
            Accept: "application/json",
            "Content-Type": "application/json",
        };
    }
}
